<template>
    <div class="main_tip">
        <div style="margin-bottom:20px;">
            <img src="../assets/images/pay_error.png" alt="">
            <span> 支付失败</span>
        </div>
        <div>
            <el-button  type="primary" size="large" style="margin-bottom:60px;" @click="$router.go(-1)">返回上一页</el-button>
            <el-button   type="primary" size="large" @click="$router.push('/user/index')">{{$t('payTip_FHZY')}}</el-button>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
    .main_tip{
        width:1200px;
        margin:0 auto;
        padding:100px 0;
        text-align: center;

    }
</style>